import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../HttpClient";

export const Createplan = createAsyncThunk("createplan", async (data) => {
    try {
        const postAllData = await httpClient.post(`/physical-verification/pv/plan`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in postAllData", response);
        return {
            result,
            StatusCode
        };
    }
    //  catch (error) {
    //     if (error.response && error.response.status === 400) {
    //         const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
    //         throw new Error(backendMessage);
    //     } else {
    //         throw new Error("Something went wrong, please try again later.");
    //     }
    // }
    catch (error) {
        let errorMessage = "Something went wrong, please try again later.";

        // Handle specific error status codes
        if (error.response) {
            const status = error.response.status;

            if (status === 400) {
                errorMessage = error.response.data?.Message || "Bad Request: Invalid input provided.";
            } else if (status === 401) {
                errorMessage = "Unauthorized: Please login to continue.";
            } else if (status === 403) {
                errorMessage = "Forbidden: You don't have permission to perform this action.";
            } else if (status === 404) {
                errorMessage = "Resource not found: The requested plan could not be found.";
            } else if (status === 500) {
                errorMessage = "Internal Server Error: Something went wrong on the server.";
            }
        }

        // Throw the relevant error message
        throw new Error(errorMessage);
    }
});

export const updatePVPlan = createAsyncThunk("updatePVPlan", async (data) => {
    try {
        const postAllData = await httpClient.put(`/physical-verification/pv/plan`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in postAllData", response);
        return {
            result,
            StatusCode
        };
    }
    //  catch (error) {
    //     if (error.response && error.response.status === 400) {
    //         const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
    //         throw new Error(backendMessage);
    //     } else {
    //         throw new Error("Something went wrong, please try again later.");
    //     }
    // }
    catch (error) {
        let errorMessage = "Something went wrong, please try again later.";

        // Handle specific error status codes
        if (error.response) {
            const status = error.response.status;

            if (status === 400) {
                errorMessage = error.response.data?.Message || "Bad Request: Invalid input provided.";
            } else if (status === 401) {
                errorMessage = "Unauthorized: Please login to continue.";
            } else if (status === 403) {
                errorMessage = "Forbidden: You don't have permission to perform this action.";
            } else if (status === 404) {
                errorMessage = "Resource not found: The requested plan could not be found.";
            } else if (status === 500) {
                errorMessage = "Internal Server Error: Something went wrong on the server.";
            }
        }

        // Throw the relevant error message
        throw new Error(errorMessage);
    }
});

export const getPV_planbyId = createAsyncThunk("getpv-planbyId", async (plan_id) => {
    try {
        const getAllData = await httpClient.get(`/physical-verification/pv/plan?plan_id=${plan_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all PV plans", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getPV_planbySupplierId = createAsyncThunk("getPV_planbySupplierId", async (supplier_id) => {
    try {
        const getAllData = await httpClient.get(`/physical-verification/pv/plan?supplier_id=${supplier_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all PV plans", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const CreateDefaultCheckpoints = createAsyncThunk("defaultCheckpoints", async (data) => {
    try {
        const postAllData = await httpClient.post("/physical-verification/pv/checkpoints", data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in creating default checkpoints", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getDefaultCheckpoints = createAsyncThunk("getdefaultCheckpoints", async (plan_id) => {
    try {
        const getAllData = await httpClient.get(`/physical-verification/pv/checkpoints?plan_id=${plan_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getAllPV_plans = createAsyncThunk("getPv-plans", async () => {
    try {
        const getAllData = await httpClient.get(`/physical-verification/pv/plan/overview?start=0&limit=20`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all PV plans", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const CreatePVLogs = createAsyncThunk("pvlogs", async (data) => {
    try {
        const postAllData = await httpClient.post(`/physical-verification/pv/logs`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in PV Logs", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getLogs = createAsyncThunk("getLogs", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/physical-verification/pv/logs/overview${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getLogByPlanId = createAsyncThunk("singleLog", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/physical-verification/pv/logs${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const getNgReviews = createAsyncThunk("getNgReview", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/physical-verification/pv/ng_review${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const getPV_Reports = createAsyncThunk("getPV_Reports", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/physical_verification/pv/logs_report_table${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});
// export const getPV_Reports = createAsyncThunk("getPV_Reports", async ({ plan_id, freq, fromTime, toTime }) => {
//     try {
//         const getAllData = await httpClient.get(`/physical-verification/pv/stats?plan_id=${plan_id}&freq=${freq}&from_time=${fromTime}&to_time=${toTime}`, {
//             headers: {
//                 "Content-Type": "application/json",
//             },
//         });
//         const response = getAllData.data;
//         const StatusCode = getAllData.status;
//         const result = response.Result;
//         console.log("success in getting default checkpoints", response);
//         return {
//             result,
//             StatusCode
//         };
//     } catch (error) {
//         if (error.response && error.response.status === 400) {
//             const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
//             throw new Error(backendMessage);
//         } else {
//             throw new Error("Something went wrong, please try again later.");
//         }
//     }
// });

export const ResolveNgReviews = createAsyncThunk("ResolveNgReviews", async (data) => {
    try {
        const postAllData = await httpClient.post(`/physical-verification/pv/ng_review`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in ResolveNgReviews", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});
export const ApprovePVNgReviews = createAsyncThunk("ApprovePVNgReviews", async (data) => {
    try {
        const postAllData = await httpClient.put(`/physical-verification/pv/ng_review`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in ResolveNgReviews", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});



export const PVuploadFile = createAsyncThunk("PVuploadFile", async (data) => {
    try {
        const postAllData = await httpClient.post(`/physical-verification/pv/logs`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        // const result = response.Result;
        console.log("success in PV Logs", response);
        return {
            StatusCode,
            response
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

const CreatePlanSlice = createSlice({
    name: "CreatePlanSlice",
    initialState: {
        loading: false,
        error: null,
        response: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(Createplan.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(Createplan.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload.result;
            })
            .addCase(Createplan.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(CreateDefaultCheckpoints.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(CreateDefaultCheckpoints.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload.result;
            })
            .addCase(CreateDefaultCheckpoints.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
})


export default CreatePlanSlice.reducer;